/*
 * fn: applyOperator
 *
 * Applies a given operator to left and right operands
 *
 */
import { type NumberOperatorsType } from '@/defs/common'

const OPERATORS: Record<NumberOperatorsType, (leftOperand: number, rightOperand: number) => boolean> = {
  atLeast: (leftOperand, rightOperand) => leftOperand >= rightOperand,
  atMost: (leftOperand, rightOperand) => leftOperand <= rightOperand,
  equal: (leftOperand, rightOperand) => leftOperand === rightOperand,
}

export const applyOperator = (operator: NumberOperatorsType, leftOperand: number, rightOperand: number) =>
  OPERATORS[operator](leftOperand, rightOperand)
